import styled from 'particles/themes/styled'
import { theme } from 'theme'

type textAlignState = 'left' | 'center' | 'right'
type justifyContentState = 'start' | 'center' | 'end'
interface StyledButtonProps {
    width?: string
    height?: string
    textAlign?: textAlignState
    hoverBackground?: string
    justifyContent?: justifyContentState
    'data-testid'?: string
}

export const StyledButton = styled.button.attrs((props: StyledButtonProps) => ({
    'data-testid': props['data-testid'],
}))<StyledButtonProps>`
    cursor: pointer;
    padding: 0;
    border: none;
    background-color: transparent;
    width: ${({ width }): string => (width ? width : 'fit-content')};
    height: ${({ height }): string => (height ? height : 'fit-content')};
    text-align: ${({ textAlign }): string => (textAlign ? textAlign : 'center')};
    font-weight: ${theme.fontWeight.medium};
    color: ${theme.colors.doveGrey};
    border-radius: 4px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: ${({ justifyContent }): string => (justifyContent ? justifyContent : 'center')};
    &:hover {
        background-color: ${({ hoverBackground }): string =>
            hoverBackground ? hoverBackground : theme.newColors.neutral100};
    }
    &:active {
        svg {
            path {
                stroke: ${theme.newColors.primary300};
            }
        }
        color: ${theme.newColors.primary300};
        font-weight: ${theme.fontWeight.bold};
        background-color: ${theme.colors.selago};
    }
`
